import { render, staticRenderFns } from "./BuyDirect.vue?vue&type=template&id=376eb77d&scoped=true"
import script from "./BuyDirect.vue?vue&type=script&lang=js"
export * from "./BuyDirect.vue?vue&type=script&lang=js"
import style0 from "./BuyDirect.vue?vue&type=style&index=0&id=376eb77d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376eb77d",
  null
  
)

export default component.exports